<template>
    <iv-modal
        :title="title"
        :width="width"
        :closable="false"
        v-model="sources.shown"
        @on-cancel="onCancel"
    >
        <iv-row type="flex">
            <iv-col span="12">
                <iv-alert type="info" style="margin-right:1em;min-height: 280px;margin-bottom:0" v-if="sources.reportData">
                    <h4>公司：{{ sources.reportData.abbreviation | default }}</h4>
                    <h4>指标：{{ sources.reportData.secondTargetName | default }}</h4>
                    <h4>指标权重：{{ sources.reportData.targetWeight | default }}</h4>
                    <h4>指标类型：{{ sources.reportData.targetType | default }}</h4>
                    <hr class="adm-hr" />
                    <span>评分规则：</span>
                    <span v-if="sources.reportData">{{
                        sources.reportData.targetRuleExplain | default
                    }}</span>
                </iv-alert>
            </iv-col>
            <iv-col v-if="value" span="12">
                <iv-form
                    :ref="FORM_NAME"
                    :model="sources.reportData"
                    label-position="top"
                    :rules="options.validation.reportData"
                >
                    <iv-form-item :error="options.validation.errors.value" prop="value">
                        <div slot="label">
                            <span>
                                {{ `报告值（单位：${repeatDataUnit}）` }}</span
                            >
                            <span></span>
                            <iv-button
                                size="small"
                                type="primary" ghost
                                @click="
                                    () => {
                                        sources.reportData.value = '无';
                                    }
                                "
                            >
                                没有报告值
                            </iv-button>
                        </div>
                        <iv-input
                            v-model="sources.reportData.value"
                            @on-change="
                                () => {
                                    options.validation.errors.value = null;
                                }
                            "
                            type="textarea"
                            :autosize="{ minRows: 5, maxRows: 10 }"
                        ></iv-input>
                    </iv-form-item>

                    <iv-form-item :label="sources.reportData.targetRule == '0' ? '人工打分': '系统打分'" prop="score">
                        <iv-input-number
                            :disabled="sources.reportData.targetRule != '0'"
                            v-model="sources.reportData.score"
                            :step="0.5"
                            :max="999"
                            :min="0"
                            style="width: 100%"
                        ></iv-input-number>
                    </iv-form-item>

                    <iv-form-item label="补充说明" prop="moreRemark">
                        <iv-input
                            v-model="sources.reportData.moreRemark"
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 8 }"
                        ></iv-input>
                    </iv-form-item>

                    <iv-form-item label="数据来源" prop="inputSource">
                        <iv-radio-group v-model="sources.reportData.inputSource">
                          <iv-radio :label="3"><span>外部数据</span></iv-radio>
                          <iv-radio :label="0"><span>年报</span></iv-radio>
                          <iv-radio :label="1"><span>社报</span></iv-radio>
                        </iv-radio-group>
                    </iv-form-item>
                </iv-form>
            </iv-col>
        </iv-row>
        <div slot="footer" style="float: left;line-height:3;">备注：若修改更新数据，需等1-2分钟生效</div>
        <iv-button type="text" size="large" slot="footer" @click="onCancel">取消</iv-button>
        <iv-button :loading="loader[REPORT_DATA]" type="primary" size="large" slot="footer" @click="onSuccess">保存</iv-button>
    </iv-modal>
</template>
<script>
import Vue from "vue";
import { BusinessError, RequestError, isNumber} from '@/utils/';
import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import ReportDataModel from "@/models/ReportDataModel";

const REPORT_DATA = ReportDataModel.ModelName;
const FORM_NAME = `${REPORT_DATA}Form`;

export default {
    mixins: [
        LoaderMixin(REPORT_DATA),
        ModelMixin({
            contact,
            models: [ReportDataModel],
        }),
    ],
    props: {
        width: {
            type: [String, Number],
            default: "500",
        },
        value: {
            type: Object,
            default: null,
        },
        type: String,
        title: String,
        shown: Boolean,
    },
    watch: {
        shown(val) {
            this.sources.shown = val;
        },
        value(val) {
            // this.sources.reportData = val;
            this.sources.reportData = this[`$${REPORT_DATA}`].schema.format(val)
        },
    },
    data() {
        return {
            FORM_NAME,
            REPORT_DATA,
            options: {
                validation: {
                    reportData: ReportDataModel.validation(),
                    errors: { value: "" },
                },
            },
            sources: {
                //双向绑定字段
                shown: false,
                reportData: null,
            },
        };
    },
    methods: {
        handleAdd() {
            this.tagsList.push(this.addVal);
            this.addVal = "";
        },
        handleClose(event, name) {
            const index = this.tagsList.indexOf(name);
            this.tagsList.splice(index, 1);
        },
        onCancel() {
            // this.sources.result = this.value;
            this.hide();
        },
        async onSuccess(){
            const validate = await this.$refs[FORM_NAME].validate();
            if (!validate) {
                this.$$warning('表单验证不通过，请继续填写。');
                return Promise.reject(new Error('表单验证不通过，请继续填写。'));
            }
            this.options.validation.errors.value = ""
            this.$$loading(REPORT_DATA)
            const result = await this.$$active(REPORT_DATA, 'save', { type: this.type, ...this.sources.reportData })

            if([BusinessError, RequestError, Error].indexOf(result.constructor) == -1){
                this.$$loaded(REPORT_DATA)
                //保存至本地并切换下一个指标

                this.$$success(`${ this.sources.reportData.secondTargetName}指标保存成功`)
                this.hide();
                this.$emit('input', result);
            }
            this.$emit('refresh');
            this.$$loaded(REPORT_DATA)
        },
        hide() {
            this.sources.shown = false;
            this.$emit("shown-changed", this.sources.shown);
        },
    },
    computed: {
        repeatDataUnit() {
            return (this.sources.reportData && this.sources.reportData.targetUnit)
                ? this.sources.reportData.targetUnit
                : "--";
        },
    },
};
</script>
<style scoped>
.ivu-tag {
    margin: 5px;
}
.panelList {
    list-style: none;
    padding: 18px 15px;
    font-size: 14px;
    line-height: 28px;
}
.radio-button {
    font-size: 15px;
    border-radius: 5px !important;
}
.addInput {
    margin: 5px;
    display: inline-block;
}
</style>
